import React from 'react';
const immediateItems = [{
  emoji: '📘',
  text: 'Los 12 tomos digitales completos (Primaria y Secundaria)'
}, {
  emoji: '📝',
  text: 'Planificaciones anuales, trimestrales y diarias'
}, {
  emoji: '🏃',
  text: 'Banco de juegos, circuitos y deportes reglados'
}, {
  emoji: '📊',
  text: 'Protocolos de Tests Físicos (resistencia, flexibilidad, fuerza)'
}, {
  emoji: '🗂️',
  text: 'Fichas de seguimiento del alumno'
}];
export function ContentPreview() {
  return <section className="w-full bg-bg-main py-16 sm:py-24 px-4" data-id="element-29">
      <div className="max-w-5xl mx-auto" data-id="element-30">
        {/* Immediate Delivery */}
        <div className="text-center" data-id="element-31">
          <h2 className="text-3xl sm:text-5xl font-serif font-black text-text-main mb-10" data-id="element-32">
            📲 ¿Qué recibís inmediatamente?
          </h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6 max-w-3xl mx-auto mb-12 text-left" data-id="element-33">
            {immediateItems.map((item, i) => <div key={i} className="bg-bg-alt rounded-2xl p-6 border border-border-light flex items-center gap-4 shadow-sm" data-id="element-34">
                <span className="text-3xl flex-shrink-0" data-id="element-35">{item.emoji}</span>
                <span className="text-text-main font-bold text-base sm:text-lg leading-snug" data-id="element-36">
                  {item.text}
                </span>
              </div>)}
          </div>

          <p className="text-primary font-serif italic text-2xl sm:text-4xl font-bold" data-id="element-37">
            Cubrís el material de todo el año
          </p>
        </div>
      </div>
    </section>;
}